
export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/93ec2f7b27ebaea73cf3a779f57bce5b.jpg"
          alt="Ford Focus Economy Car Rental"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 text-center px-6 max-w-4xl mx-auto w-full">
        <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
          Affordable Car Rentals for Gig Workers & Others
        </h1>
        <p className="text-xl md:text-2xl text-white/90 mb-8 max-w-2xl mx-auto">
          Quality economy vehicles at unbeatable weekly rates. Get back on the road and back to work.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            onClick={() => scrollToSection('booking')}
            className="px-8 py-4 bg-teal-600 text-white text-lg font-semibold rounded-lg hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Reserve Your Car
          </button>
          <button
            onClick={() => scrollToSection('fleet')}
            className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white text-lg font-semibold rounded-lg hover:bg-white/20 transition-all border-2 border-white/30 whitespace-nowrap cursor-pointer"
          >
            View Fleet
          </button>
        </div>
      </div>
    </section>
  );
}
